import { useRef } from 'react';
import useOnScreen from '@rio-cloud/rio-uikit/hooks/useOnScreen';
import { useAdvertisementSeen } from '../../hooks/useAdvertisementSeen';
import type { DriverChatCampaign } from '../../hooks/useGetUpsellingCampaign';
import { CampaignCView } from './CampaignCView';
import { CampaignDView } from './CampaignDView';

export const DriverChatUpsellingView = ({ campaign }: { campaign: DriverChatCampaign }) => {
    const ref = useRef<HTMLDivElement>(null);
    const inView = useOnScreen(ref);
    useAdvertisementSeen(inView);

    const CampaignView = campaign.id === 'campaignC' ? CampaignCView : CampaignDView;
    return <CampaignView viewRef={ref} trackingCategory={campaign.trackingCategory} />;
};
